import React, { Component } from 'react';
//redux
import { connect } from "react-redux";
import { getHeaderData } from "common/Header/store/actionCreators";
import { setMainTabbarData } from "./common/Main/store/actionCreators";
import { getUserInfoData } from "common/User/store/actionCreators";
import { getActivityData,setActivitySelectData } from "./common/VoteActivity/store/actionCreators";
//antd
import { TabBar } from 'antd-mobile-v2';
//路由
import {
    Link,useHistory
} from "react-router-dom";

//样式
import { MainContainer } from "./style";

//组件
import WagesHome from "./common/WagesHome";
import WagesRank from "./common/WagesRank";
import WagesIJoin from "./common/WagesIJoin";
import ActivityDescription from "./common/ActivityDescription";
import { isNotBlank } from "./util/StringUtil";
import  "./util/imgUtil";
import Header from './common/Header'
import myRequest from './request'
import Item from 'antd/lib/list/Item';

let { innerHeight, innerWidth } = window
class main extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedTab: 'home',
            hidden: false,
            fullScreen: false,
            tktype: false,
            haveActivity:false
        }
    }

    componentDidMount() {
        // this.props._getHeaderData({
        //     title: "首页",
        //     type: 0,
        //     rightType: 0,
        //     rightFun: {},
        //     path: ''
        // });

        const location = this.props.location;
        const search = location.search.substr(1); //截取local,并删除第一个?号字符
        //     let authtoken = this.props.match.params.authtoken;
        //    console.log("this.props.match",this.props);
        if (isNotBlank(search)) {

            let a = myRequest.setRequestAuthtoken(search)
            let that = this
            a.then(res => {
                console.log('res', res)
                let { errcode } = res
                if (errcode === '200') {
                    that.setState({
                        tktype: true
                    })
                }
            })



        } else {
            this.setState({
                tktype: true
            })
        }



        let activityId = this.props.match.params.activityId;
        let select = this.props.match.params.select;
        if (isNotBlank(activityId)) {
            this.setState({activityId:activityId})
        }
        if (isNotBlank(select)) {
            this.setState({selectedTab:select})
        }

        this.props._getUserInfoData();
        this.props._getActivityData();


    }


    UNSAFE_componentWillReceiveProps(nextProps,nextContext) {
        //console.log('main UNSAFE_componentWillReceiveProps:',nextProps);
        const isLoginError = nextProps.isLoginError;
        if(isLoginError){
            this.props.history.push('/login');
        }
        const {activityId} = this.state;
        const activityList = nextProps.activityList;
        if(activityList&&activityList.length>0&&isNotBlank(activityId)){
            activityList.map(item =>{
                if(item.id ===activityId){
                    this.props._setActivitySelectData(item);
                    return false;
                }
            });

        }else if(activityList===null){
            this.props._getActivityData();
        }

        const activity =  nextProps.activity
        if(activity){
            this.props._getHeaderData({
                title: activity.title,
                type: 0,
                rightType: 0,
                rightFun: {},
                path: ''
            });
        }else{
            this.props._getHeaderData({
                title: '',
                type: 0,
                rightType: 0,
                rightFun: {},
                path: ''
            });
        }

    }



    render() {

        const {activity,selectedTab,history} = this.props;
        return (

            <>
                <Header history={history} />
                <MainContainer style={this.state.fullScreen ? { position: 'fixed', height: '100%', width: '100%', top: 0 } : { height: innerHeight -50 }}>

                    {
                        activity?.voteState&&
                            <TabBar
                                unselectedTintColor="#949494"
                                tintColor="#36BEF1"
                                barTintColor="white"
                                hidden={this.state.hidden}
                            >
                                <TabBar.Item
                                    title="首页"
                                    key="home"
                                    icon={<img src={require("assets/images/home.png")} style={{width: "25px",height: "25px"}} alt="" />
                                    }
                                    selectedIcon={<img src={require("assets/images/home-selected.png")} style={{width: "25px",height: "25px"}} alt="" />
                                    }
                                    selected={selectedTab === 'home'}
                                    // badge={1}
                                    onPress={() => {
                                         this.props._setMainTabbarData('home')
                                    }}
                                    // data-seed="logId"
                                >
                                    <WagesHome history={history} />
                                </TabBar.Item>
                                <TabBar.Item
                                    title="投票排行"
                                    key="rank"
                                    icon={<img src={require("assets/images/rank.png")} style={{width: "25px",height: "25px"}} alt="" />
                                    }
                                    selectedIcon={<img src={require("assets/images/rank-selected.png")} style={{width: "25px",height: "25px"}} alt="" />
                                    }
                                    selected={selectedTab === 'rank'}
                                    // badge={1}
                                    onPress={() => {
                                        this.props._setMainTabbarData('rank')
                                    }}
                                    // data-seed="logId"
                                >
                                    {selectedTab === 'rank'&&<WagesRank history={history} />}

                                </TabBar.Item>

                                <TabBar.Item
                                    icon={<img src={require("assets/images/description.png")} style={{width: "25px",height: "25px"}} alt="" />}
                                    selectedIcon={<img src={require("assets/images/description-selected.png")} style={{width: "25px",height: "25px"}} alt="" />}
                                    title="活动说明"
                                    key="description"
                                    selected={selectedTab === 'description'}
                                    onPress={() => {
                                        this.props._setMainTabbarData('description')
                                    }}
                                >
                                    {selectedTab === 'description'&&<ActivityDescription history={history} />}
                                </TabBar.Item>
                                <TabBar.Item
                                    icon={<img src={require("assets/images/join.png")} style={{width: "25px",height: "25px"}} alt="" />}
                                    selectedIcon={<img src={require("assets/images/join-selected.png")} style={{width: "25px",height: "25px"}} alt="" />}
                                    title="我要参加"
                                    key="join"
                                    selected={selectedTab === 'join'}
                                    onPress={() => {
                                        this.props._setMainTabbarData('join')
                                    }}
                                >
                                    {selectedTab === 'join'&&<WagesIJoin history={history} />}
                                </TabBar.Item>
                            </TabBar>

                    }
                    {
                        activity?.voteState===false&&
                        <TabBar
                            unselectedTintColor="#949494"
                            tintColor="#36BEF1"
                            barTintColor="white"
                            hidden={this.state.hidden}
                        >
                            <TabBar.Item
                                title="首页"
                                key="home"
                                icon={<img src={require("assets/images/home.png")} style={{width: "25px",height: "25px"}} alt="" />
                                }
                                selectedIcon={<img src={require("assets/images/home-selected.png")} style={{width: "25px",height: "25px"}} alt="" />
                                }
                                selected={selectedTab === 'home'}
                                // badge={1}
                                onPress={() => {
                                    this.props._setMainTabbarData('home')
                                }}
                                // data-seed="logId"
                            >
                                <WagesHome history={history} />
                            </TabBar.Item>


                            <TabBar.Item
                                icon={<img src={require("assets/images/description.png")} style={{width: "25px",height: "25px"}} alt="" />}
                                selectedIcon={<img src={require("assets/images/description-selected.png")} style={{width: "25px",height: "25px"}} alt="" />}
                                title="活动说明"
                                key="description"
                                selected={selectedTab === 'description'}
                                onPress={() => {
                                    this.props._setMainTabbarData('description')
                                }}
                            >
                                {selectedTab === 'description'&&<ActivityDescription history={history} />}
                            </TabBar.Item>
                            {/*<TabBar.Item*/}
                            {/*    icon={<img src={require("assets/images/join.png")} style={{width: "25px",height: "25px"}} alt="" />}*/}
                            {/*    selectedIcon={<img src={require("assets/images/join-selected.png")} style={{width: "25px",height: "25px"}} alt="" />}*/}
                            {/*    title="我要参加"*/}
                            {/*    key="join"*/}
                            {/*    selected={selectedTab === 'join'}*/}
                            {/*    onPress={() => {*/}
                            {/*        this.props._setMainTabbarData('join')*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*    {selectedTab === 'join'&&<WagesIJoin history={history} />}*/}
                            {/*</TabBar.Item>*/}
                        </TabBar>

                    }


                </MainContainer>

            </>
        );
    }
}


const mapState = state => {

    let selectedTab = state.getIn(['serch', 'selectedTab'])
    let  activityList =state.getIn(['activity', 'activity']);
    let  activity =state.getIn(['activity', 'activitySelect']);
    let  isLoginError =state.getIn(['user', 'isLoginError']);
    return {
        selectedTab,
        activityList,
        isLoginError,
        activity
    }
}
const mapDispatch = dispatch => {
    return {
        _getHeaderData(data) {
            dispatch(getHeaderData(data))
        },

        _setMainTabbarData(data) {
            console.log('------', data)
            dispatch(setMainTabbarData(data))
        },
        _getUserInfoData(data) {
            dispatch(getUserInfoData(data))
        },
        _getActivityData(data) {
            dispatch(getActivityData(data))
        },
        _setActivitySelectData(data) {
            dispatch(setActivitySelectData(data))
        },
    }
}

export default connect(mapState, mapDispatch)(main)
